export let copilotSettingsDiagDataCollectorDescription = "B07BHb";
export default {copilotSettingsDiagDataCollectorDescription};